(() => {
  if (window.__gphant) return;
  window.__gphant = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Entradas al hacer scroll
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px' })
    : null;
  $$('.gp [data-reveal]').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  // Intro con el logo y arranque de la portada
  const startHero = () => requestAnimationFrame(() => $$('.gp-js').forEach(el => el.classList.add('is-loaded')));
  const intro = $('.gp-intro');
  const html = document.documentElement;

  if (intro && html.classList.contains('gp-intro-on')) {
    const fill = $('.gp-intro__fill', intro);
    const started = performance.now();
    let done = false;
    requestAnimationFrame(() => { fill.style.transform = 'scaleX(.35)'; });

    const finish = () => {
      if (done) return;
      done = true;
      fill.style.transform = 'scaleX(1)';
      try { sessionStorage.setItem('gp-intro', '1'); } catch (e) {}
      setTimeout(() => {
        intro.classList.add('is-out');
        setTimeout(startHero, 250);
        setTimeout(() => {
          html.classList.remove('gp-intro-on');
          intro.remove();
        }, 900);
      }, 350);
    };

    const whenLoaded = () => setTimeout(finish, Math.max(0, 1500 - (performance.now() - started)));
    if (document.readyState === 'complete') whenLoaded();
    else window.addEventListener('load', whenLoaded);
    setTimeout(finish, 3200);
    intro.addEventListener('click', finish);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' || e.key === 'Enter') finish(); });
  } else {
    html.classList.remove('gp-intro-on');
    if (intro) intro.remove();
    startHero();
  }

  // Inclinación 3D de las tarjetas, solo con mouse
  if (matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) {
    document.addEventListener('pointermove', e => {
      const media = e.target.closest && e.target.closest('.gp-product__media');
      if (!media || e.pointerType !== 'mouse') return;
      const r = media.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5;
      const y = (e.clientY - r.top) / r.height - .5;
      media.classList.add('is-tilting');
      media.style.setProperty('--ry', `${x * 16}deg`);
      media.style.setProperty('--rx', `${y * -16}deg`);
      media.style.setProperty('--tx', `${x * 18}px`);
      media.style.setProperty('--ty', `${y * 18}px`);
    });
    document.addEventListener('pointerout', e => {
      const media = e.target.closest && e.target.closest('.gp-product__media');
      if (!media || media.contains(e.relatedTarget)) return;
      media.classList.remove('is-tilting');
      ['--rx', '--ry', '--tx', '--ty'].forEach(v => media.style.removeProperty(v));
    });
  }

  // Polera en 3D
  $$('.gp-spin').forEach(spin => {
    const card = $('.gp-spin__card', spin);
    const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let angle = -20, velocity = 0, dragging = false, lastX = 0, idleUntil = 0, visible = false, last = 0;

    const paint = () => card.style.setProperty('--a', `${angle}deg`);

    function tick(t) {
      const dt = Math.min(48, t - (last || t));
      last = t;
      if (!dragging) {
        if (Math.abs(velocity) > .01) {
          angle += velocity * dt;
          velocity *= .94;
        } else if (!still && t > idleUntil) {
          angle += .022 * dt;
        }
      }
      paint();
      if (visible) requestAnimationFrame(tick);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (visible) { last = 0; requestAnimationFrame(tick); }
      }).observe(spin);
    }

    spin.addEventListener('pointerdown', e => {
      if (e.target.closest('a')) return;
      dragging = true; lastX = e.clientX; velocity = 0;
      spin.classList.add('is-dragging');
      spin.setPointerCapture(e.pointerId);
    });
    spin.addEventListener('pointermove', e => {
      if (!dragging) return;
      const dx = e.clientX - lastX;
      lastX = e.clientX;
      angle += dx * .6;
      velocity = dx * .03;
    });
    const release = () => {
      if (!dragging) return;
      dragging = false;
      idleUntil = performance.now() + 2500;
      spin.classList.remove('is-dragging');
    };
    spin.addEventListener('pointerup', release);
    spin.addEventListener('pointercancel', release);
    spin.addEventListener('keydown', e => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      angle += e.key === 'ArrowRight' ? 30 : -30;
      idleUntil = performance.now() + 4000;
      paint();
    });
    paint();
  });

  // WhatsApp: el número vive en la sección del pie; sin número, los enlaces de la portada siguen ocultos
  const wa = $('[data-gp-wa-url]');
  if (wa) {
    $$('a[data-gp-wa]').forEach(a => { a.href = wa.dataset.gpWaUrl; });
    $$('[data-gp-wa]').forEach(el => { el.hidden = false; });
  }

  // Riel de fotos: arrastrar con el mouse
  $$('.gp-rail').forEach(rail => {
    let startX = 0, startScroll = 0, down = false;
    rail.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse') return;
      down = true; startX = e.clientX; startScroll = rail.scrollLeft;
      rail.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', e => {
      if (down) rail.scrollLeft = startScroll - (e.clientX - startX);
    });
    window.addEventListener('pointerup', () => {
      down = false;
      rail.classList.remove('is-dragging');
    });
  });

  // Filtros por tipo de producto
  $$('[data-gp-filters]').forEach(group => {
    const grid = $('#' + group.dataset.gpFilters);
    group.addEventListener('click', e => {
      const btn = e.target.closest('[data-line]');
      if (!btn) return;
      $$('[data-line]', group).forEach(b => b.setAttribute('aria-pressed', b === btn));
      $$('.gp-product', grid).forEach(card => {
        card.hidden = btn.dataset.line !== 'all' && card.dataset.line !== btn.dataset.line;
        if (!card.hidden) card.classList.add('is-in');
      });
    });
  });

  // Frente y espalda
  document.addEventListener('click', e => {
    const flip = e.target.closest('.gp-product__flip');
    if (!flip) return;
    const back = flip.closest('.gp-product').classList.toggle('show-back');
    flip.setAttribute('aria-pressed', back);
    flip.textContent = back ? flip.dataset.front : flip.dataset.back;
  });

  // Agregar al carrito sin salir de la página
  const toast = $('.gp-toast');
  let toastTimer;

  function showToast(text) {
    if (!toast) return;
    $('[data-gp-toast-text]', toast).textContent = text;
    toast.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-open'), 4000);
  }

  async function refreshCount() {
    const cart = await fetch(root + 'cart.js').then(r => r.json());
    $$('[data-cart-count], .cart-count-bubble span[aria-hidden="true"], .cart-count').forEach(el => {
      el.textContent = cart.item_count;
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
  }

  document.addEventListener('submit', async e => {
    const form = e.target.closest('.gp-product__form');
    if (!form || !window.fetch) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    const label = btn.innerHTML;
    btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message);
      showToast(`${data.product_title} · ${data.variant_title || ''}`.replace(/ · $/, '') + ' en tu bolso');
      refreshCount().catch(() => {});
    } catch (err) {
      showToast(err.message || 'No pudimos agregar la prenda. Intenta de nuevo.');
    } finally {
      btn.disabled = false;
      btn.innerHTML = label;
    }
  });

  // Calculadora de talla
  $$('[data-gp-fit]').forEach(section => {
    const sizes = JSON.parse(section.dataset.gpFit);
    const order = Object.keys(sizes);
    const form = $('form', section);
    const out = $('[data-gp-fit-size]', section);

    function recommend() {
      const f = form.elements;
      const h = Number(f.height.value) || 175;
      const w = Number(f.weight.value) || 80;
      let i;
      if (w < 66 && h < 170) i = 0;
      else if (w < 75 && h < 176) i = 1;
      else if (w < 86 && h < 183) i = 2;
      else if (w < 98) i = 3;
      else i = 4;
      if (f.cut.value === 'pump') i += 1;
      if (f.cut.value === 'fitted') i -= 1;
      return order[Math.max(0, Math.min(order.length - 1, i))];
    }

    function render() {
      const size = recommend();
      if (out.textContent !== size) {
        out.textContent = size;
        out.classList.remove('swap');
        void out.offsetWidth;
        out.classList.add('swap');
      }
      const [w, l] = sizes[size];
      $('[data-gp-fit-dims]', section).textContent = `${w} cm de ancho, ${l} cm de largo`;
      $$('[data-gp-fit-label]', section).forEach(el => { el.textContent = size; });
    }

    form.addEventListener('input', render);
    form.addEventListener('submit', e => e.preventDefault());
    render();

    $('[data-gp-fit-apply]', section).addEventListener('click', () => {
      const size = recommend();
      $$('.gp-product__form').forEach(f => {
        const radio = $$('input[data-size]', f).find(r => r.dataset.size.toUpperCase() === size && !r.disabled);
        if (radio) radio.checked = true;
      });
      const shop = $('.gp-shop');
      if (shop) shop.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // Tabla de tallas: una pestaña por prenda
  $$('.gp-chart-tabs').forEach(list => {
    const tabs = $$('[role="tab"]', list);
    const select = tab => tabs.forEach(t => {
      const on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });
  });

  // Tabla de tallas
  $$('[data-gp-open-sizes]').forEach(b => b.addEventListener('click', e => {
    const sheet = $('#gp-sizes');
    if (!sheet || !sheet.showModal) return;
    e.preventDefault();
    sheet.showModal();
  }));
  $$('.gp-sheet').forEach(d => {
    $('[data-gp-close]', d).addEventListener('click', () => d.close());
    d.addEventListener('click', e => { if (e.target === d) d.close(); });
  });
})();
